@import "../../less/variables.less";

.textContainer {
  padding: var(--dds-spacing-medium-20);
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  gap: var(--dds-spacing-small-12);
}

.textContainer > * {
  margin-top: 0;
  margin-bottom: 0;
  font-size: var(--dds-font-size-12);
}

.textContainer > p {
  margin-top: 0;
  margin-bottom: 0;
}

.virksomhetsKort {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: var(--dds-spacing-small-12);
  border: none;
  text-align: left;
  color: black;
  background: var(--dds-bg-primary-mobile);
  border-radius: var(--dds-spacing-small-16);
}

.virksomhetsKort img {
  max-height: var(--dds-spacing-large-48);
  padding-left: var(--dds-spacing-medium-20);
}

.virksomhetsKortHoverable {
  background: var(--dds-card-bg-accent);
}

.virksomhetsKortHoverable .textContainer h2 {
  font-weight: 500;
  text-decoration: underline;
}

.virksomhetsKort .textContainer h3 {
  font-weight: 500;
}

.virksomhetsKortHoverable:hover {
  background: var(--dds-card-bg-secondary);
  cursor: pointer;
}
